import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Buyer/notfound/notfound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`nf-page ${visible ? 'nf-page--visible' : ''}`}>

      {/* ── Floating background blobs ── */}
      <div className="nf-blob nf-blob--1" />
      <div className="nf-blob nf-blob--2" />
      <div className="nf-blob nf-blob--3" />

      {/* ── Main content ── */}
      <div className="nf-content">

        {/* ── 404 number ── */}
        <div className="nf-number-wrap">
          <span className="nf-digit nf-digit--4a">4</span>
          <div className="nf-zero-wrap">
            <span className="nf-digit nf-digit--0">0</span>
            {/* orbit ring */}
            <div className="nf-ring" />
            <div className="nf-ring nf-ring--2" />
            {/* orbiting dot */}
            <div className="nf-orbit-dot" />
            <div className="nf-orbit-dot nf-orbit-dot--2" />
          </div>
          <span className="nf-digit nf-digit--4b">4</span>
        </div>

        {/* ── Divider line ── */}
        <div className="nf-divider" />

        {/* ── Text block ── */}
        <div className="nf-text-block">
          <h1 className="nf-heading">Page Not Found</h1>
          <p className="nf-subtext">
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>
        </div>

        {/* ── Actions ── */}
        <div className="nf-actions">
          <button className="nf-btn nf-btn--primary" onClick={() => navigate('/')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Back to Home
          </button>
          {/* <button className="nf-btn nf-btn--secondary" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
            Go Back
          </button> */}
        </div>

        {/* ── Footer hint ── */}
        <p className="nf-hint">
          Error code: <code>404</code> &nbsp;·&nbsp; Estate Experts
        </p>
      </div>

      {/* ── Animated grid lines ── 
      <div className="nf-grid" aria-hidden="true">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="nf-grid-line" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </div>*/}
    </div>
  );
};

export default NotFound;